import { render, staticRenderFns } from "./ProtocolViewReport.vue?vue&type=template&id=0ba900da&"
import script from "./ProtocolViewReport.vue?vue&type=script&lang=js&"
export * from "./ProtocolViewReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports